import { render, staticRenderFns } from "./VFilters.vue?vue&type=template&id=94f2e1b8"
import script from "./VFilters.vue?vue&type=script&lang=js"
export * from "./VFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports